import { Flex, Stack } from '@chakra-ui/react';
import { Outlet } from 'react-router-dom';
import { HelivanColor } from '../helivan/HelivanColor';
import { GlobalTopbar } from './GlobalTopbar';
import { TourProvider } from '../Tour/TourContext';

export const SidebarLayout = () => {
  return (
    <TourProvider>
      <Stack
        h="100vh"
        spacing={0}
        position="sticky"
        bg={HelivanColor.background.secondary}
      >
        <GlobalTopbar />
        <Flex flex="1" w="100%" h="100%" overflow="hidden">
          <Flex
            flex="1"
            overflowX="hidden"
            position="relative"
            height="100%"
            px={{ base: '12px', sm: '16px', md: '24px' }}
            pb={{ base: '12px', md: '18px' }}
          >
            <Outlet />
          </Flex>
        </Flex>
      </Stack>
    </TourProvider>
  );
};
